var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('b-spinner',{attrs:{"small":""}}):_c('div',_vm._l((_vm.pillZones),function(zone){return _c('b-badge',{key:zone.id,staticClass:"mr-1",attrs:{"pill":"","variant":{
        'state': 'success',
        'zone': 'warning',
        'city': 'info',
      }[zone.type]}},[_vm._v(" "+_vm._s(zone.name)+" ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }